import PropertyDetailPerformance from './PropertyDetailPerformance';

export default PropertyDetailPerformance;